import React    from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';

import StackView from './components/StackView';

ReactDOM.render(
  <StackView />,
  document.getElementById('root')
);